import { browserHistory } from 'react-router'

export const USER_UPDATE_SUBMITTED = 'USER_UPDATE_SUBMITTED'
export const USER_UPDATED = 'USER_UPDATED'
export const USER_UPDATED_ERROR = 'USER_UPDATED_ERROR'

const updateUserMutation = `mutation($sub:String!, $cellnumber:String!, $desc:String!) {
  updatedUser: updateUserCellnumber(
    sub: $sub,
    cellnumber: $cellnumber,
    verificationDescription: $desc
  ) {
    sub
  }
}`

export const updateUserAsAdmin = values => {
  return dispatch => {
    dispatch(({
      type: USER_UPDATE_SUBMITTED,
      values
    }))
    return fetch('/api', {
      credentials: 'same-origin',
      method: 'POST',
      body: JSON.stringify({
        query: updateUserMutation,
        variables: {
          sub: values.sub,
          cellnumber: values.cellnumber,
          desc: values.verificationDescription
        }
      }),
      headers: new Headers({
        Accept: 'application/json',
        'content-type': 'application/json'
      })
    })
    .then(response => response.json())
    .then(json => {
      console.log('results updating user', json);
      browserHistory.push('/')
      if (json.errors) {
        return dispatch({
          type: USER_UPDATED_ERROR,
          err: json.errors.map(e => e.message).join(' ')
        })
      }
      alert('User updated')
      return dispatch({ type: USER_UPDATED })
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/as-admin.js